import type { EarlyFreedomLevel } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";

export const getEarlyFreedomLevel = (
	targetExpenses: number | undefined,
	passiveToday: number,
): EarlyFreedomLevel => {
	if (targetExpenses === undefined) return "cold";
	if (passiveToday > 0) return "full";
	return "lite";
};
